import { routing } from "../../routing.js";
import { SortOrder } from "../../types/index.js";
import { isUnsafeNewsroomUpdateErrorResponse } from "./lib.js";
export function createClient(api) {
  async function list(newsroomId, {
    sortOrder
  } = {}) {
    const url = routing.newsroomLanguagesUrl.replace(':newsroom_id', String(newsroomId));
    return api.get(url, {
      query: {
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }
  async function get(newsroomId, localeCode, {
    fallback
  } = {}) {
    const url = routing.newsroomLanguagesUrl.replace(':newsroom_id', String(newsroomId));
    const {
      language
    } = await api.get(`${url}/${localeCode}`, {
      query: {
        fallback: fallback || undefined
      }
    });
    return language;
  }
  async function enable(newsroomId, localeCode, payload = {}) {
    const url = routing.newsroomLanguagesUrl.replace(':newsroom_id', String(newsroomId));
    const {
      language
    } = await api.put(`${url}/${localeCode}`, {
      payload
    });
    return language;
  }
  async function disable(newsroomId, localeCode, {
    replacement
  }) {
    const url = routing.newsroomLanguagesUrl.replace(':newsroom_id', String(newsroomId));
    return api.delete(`${url}/${localeCode}`, {
      payload: {
        replacement
      }
    });
  }
  async function update(newsroomId, localeCode, payload, options = {}) {
    const url = routing.newsroomLanguagesUrl.replace(':newsroom_id', String(newsroomId));
    const force = Boolean(options.force);
    const {
      language
    } = await api.patch(`${url}/${localeCode}`, {
      query: {
        force: force ? true : undefined
      },
      payload
    });
    return language;
  }
  async function makeDefault(newsroomId, localeCode) {
    return update(newsroomId, localeCode, {
      is_default: true
    });
  }

  /**
   * This operation should be used for single-language newsrooms
   * to switch default language to another code.
   *
   * This will also move all linked stories, if any, to the new language code,
   * but will require a confirmation.
   */
  async function switchDefaultLanguage(newsroomId, localeCode, newLocaleCode, forceUnsafeOperation = false) {
    try {
      const language = await update(newsroomId, localeCode, {
        code: newLocaleCode
      }, {
        force: forceUnsafeOperation
      });
      return {
        status: 'success',
        language
      };
    } catch (error) {
      if (isUnsafeNewsroomUpdateErrorResponse(error)) {
        return error;
      }
      throw error;
    }
  }
  return {
    list,
    get,
    enable,
    disable,
    update,
    makeDefault,
    switchDefaultLanguage
  };
}